import React, {Component} from "react";
import {Card, CardBody, CardSubtitle, CardText, CardTitle, Col, Container, Navbar, NavbarBrand, Row} from "reactstrap";
import logo from "../../../assets/img/brand/logo.png";
import APIClient from "../../../components/ApolloClientComponent/ApolloClient";
import gql from "graphql-tag";

const WelcomeNavbar = (props) => (
	<Navbar
		style={{
			backgroundColor: props.navbarColor || "#46b6ea"
		}}>
		<div className="container">
			<NavbarBrand>
				<img className="navbar-logo" src={props.navbarLogo || logo} alt="Logo"/>
			</NavbarBrand>
		</div>
	</Navbar>
);


export default class JobWelcomePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			job: null,
			loading: true,
			jobId: "DEMO",
			lighterPrimaryColor: null
		};
		const query = gql`
			query getJob($id: ID!) {
				job(id: $id) {
					id,
					position,
					company {
						name,
						logoUrl,
						email,
						about,
						themeData {
							navbarLogoUrl,
							navbarColor,
							primaryColor
						}
					}
					location {
						name
					}
					positionType
					description
					responsibilities {id, title}
					qualifications {id, title}
					perks {id, title}
				}
			}
		`;
		APIClient.query({
			fetchPolicy: "no-cache",
			query: query,
			variables: {
				id: "DEMO"
			}
		}).then((result) => {
			this.setState({job: result.data.job, loading: false});
		}).catch(error => {
			this.setState({loading: false});
			console.log(error);
		});
	}


	render() {
		//TODO: Complete this page
		if (this.state.loading) {
			return null;
		}
		const {job} = this.state;
		let {
			navbarLogoUrl,
			navbarColor,
			primaryColor
		} = this.state.job.company.themeData || {};
		primaryColor = primaryColor || "#46b6ea";

			//Determining the Primary Lighter color
			if (primaryColor ==="#e6194b")
			this.state.lighterPrimaryColor = "#fff3f3";
			if (primaryColor ==="#3cb44b")
			this.state.lighterPrimaryColor = "#eefff0";
			if (primaryColor ==="#ffe119")
			this.state.lighterPrimaryColor = "#fffceb";
			if (primaryColor ==="#4363d8")
			this.state.lighterPrimaryColor = "#eff2ff";
			if (primaryColor ==="#f58231")
			this.state.lighterPrimaryColor = "#fff6ef";
			if (primaryColor ==="#911eb4")
			this.state.lighterPrimaryColor = "#fcf1ff";
			if (primaryColor ==="#42d4f4")
			this.state.lighterPrimaryColor = "#f0fcff";
			if (primaryColor ==="#f032e6")
			this.state.lighterPrimaryColor = "#ffeffe";
			if (primaryColor ==="#bfef45")
			this.state.lighterPrimaryColor = "#faffee";
			if (primaryColor ==="#fabebe")
			this.state.lighterPrimaryColor = "#fff0f0";
			if (primaryColor ==="#469990")
			this.state.lighterPrimaryColor = "#f0fffd";
			if (primaryColor ==="#e6beff")
			this.state.lighterPrimaryColor = "#ffffff";
			if (primaryColor ==="#9a6324")
			this.state.lighterPrimaryColor = "#fff6ec";
			if (primaryColor ==="#fffac8")
			this.state.lighterPrimaryColor = "#ffffff";
			if (primaryColor ==="#800000")
			this.state.lighterPrimaryColor = "#fff0f0";
			if (primaryColor ==="#aaafc3")
			this.state.lighterPrimaryColor = "#ffffff";
			if (primaryColor ==="#808000")
			this.state.lighterPrimaryColor = "#ffffe7";
			if (primaryColor ==="#ffd8b1")
			this.state.lighterPrimaryColor = "#ffffff";
			if (primaryColor ==="#000075")
			this.state.lighterPrimaryColor = "#ededff";
			if (primaryColor ==="#a9a9a9")
			this.state.lighterPrimaryColor = "#ffffff";
			if (primaryColor ==="#000000")
			this.state.lighterPrimaryColor = "#ffffff";
			if (primaryColor ==="#ff0000")
			this.state.lighterPrimaryColor = "#ffe9e9";
			if (primaryColor ==="#fffc00")
			this.state.lighterPrimaryColor = "#ffffe9";
			if (primaryColor ==="#0099ff")
			this.state.lighterPrimaryColor = "#e9f6ff";
			//End of determining the Lighter Primary color

		return (
			<div
				className={"bg-white"}
				style={{
					height: "125vh",
					paddingBottom: "16px",
					fontFamily: "Open Sans",
					overflow: "auto",
					fontSize: '1rem'
				}}>
				<WelcomeNavbar navbarColor={navbarColor} navbarLogo={navbarLogoUrl}/>
				<Container className="mt-4">
					<Row>
						<Col sm={8}>
							<Card outline className="mb-3 rounded-lg" style={{borderColor: "#dddddd"}}>
								<CardBody>
									<div className="pr-0 mb-4">
											<span
												style={{color: "#000000"}}
												className="h4 my-0 font-weight-semi-bold">
												{job.position} <span className="d-none d-lg-inline-block"> | </span>
											</span>
										<span className="h5 my-0 p-2 text-gray text-nowrap">
												{job.positionType === "FULL_TIME" ? "Full Time" : job.positionType === "PART_TIME" ? "Part Time" : job.positionType} |
											</span>
										<span className="h5 my-0 py-2 text-gray">
												{job.location.name}
											</span>
									</div>
									<p className="small">
										{job.description}
									</p>
									{/* Responsibilities */}

									{job.responsibilities && job.responsibilities.length > 0
										? <div className="position-relative">
											<div
												style={{color: "#000000"}}
												className="mb-3 mt-2 font-weight-semi-bold">
												Responsibilities
											</div>
											<ul className="small" style={{paddingLeft: "20px"}}>
												{job.responsibilities.map(r => (<li key={r.id}>{r.title}</li>))}
											</ul>
										</div>
										: null
									}

									{/* Requirements */}
									{job.qualifications && job.qualifications.length > 0
										? <div className="position-relative">
											<div
												style={{color: "#000000"}}
												className="mb-3 mt-2 font-weight-semi-bold">Qualifications
											</div>
											<ul className="small" style={{paddingLeft: "20px"}}>
												{job.qualifications.map(q => (<li key={q.id}>{q.title}</li>))}
											</ul>
										</div>
										: null
									}
									{/* Perks */}
									{job.perks && job.perks.length > 0
										? <div className="position-relative">
											<div
												style={{color: "#000000"}}
												className="mb-3 mt-2 font-weight-semi-bold">What we offer
											</div>
											<ul className="small" style={{paddingLeft: "20px"}}>
												{job.perks.map(p => (<li key={p.id}>{p.title}</li>))}
											</ul>
										</div>
										: null
									}
								</CardBody>
							</Card>
						</Col>
						<Col sm={4}>
							<Card className="mb-3 rounded-lg" style={{borderColor: primaryColor}}>
								<CardBody className="rounded-lg" style={{border: primaryColor}}>
									<h6 className="font-weight-semi-bold">Get notified for jobs</h6>
									<p className="small">Sign up to recieve job alerts</p>
									<form onSubmit={this.submitForm}>
										<div className="row m-0">
											<div className="col pl-0 pr-3">
												<input
													disabled={true}
													className="form-control form-control-sm rounded-lg"/>
											</div>
											<div className="col flex-grow-0 p-0">
												<button
													type="submit"
													disabled={true}
													style={(job.company.themeData || {}).primaryColor ? {
														backgroundColor: primaryColor,
														borderColor: primaryColor
													} : null}
													className="btn btn-sm btn-primary rounded-lg text-white text-nowrap">
													Sign Up
												</button>
											</div>
										</div>
									</form>
								</CardBody>
							</Card>
							<Card outline className="mb-2 rounded-lg" style={{borderColor: primaryColor}}>
								<CardBody className="rounded-lg" style={{border: "1px solid #D3FAFF",backgroundColor: this.state.lighterPrimaryColor}}>
									<ul className="small" style={{paddingLeft: "20px"}}>
										<li className="mb-3">
											Any detected <u><b className="font-weight-semi-bold">plagiarism</b></u> will result in the application
											being flagged which will make you likely to
											be removed from consideration for the position.
										</li>
										<li className="mb-3">
											Any questions or issues regarding the interview please contact
											<a
												style={{color: primaryColor}}
												href="mailto:info@talentscript.com">TalentScript</a>.
										</li>
										<li className="mb-3">
											Data entered will be collected and analyzed as TalentScript sees fit for the hiring
											process.
										</li>
									</ul>
									<div className="font-weight-semi-bold small mb-4">
										Note: After the interview is completed, please verify the link sent to your email.
										Verification is an important step to proceed with your candidature.
									</div>
									<div className="text-center">
										<a 
											target="_blank"
											style={(job.company.themeData || {}).primaryColor ? {
												backgroundColor: primaryColor,
												borderColor: primaryColor
											} : null}
											className="btn btn-primary rounded-lg text-white"
										>Start Interview</a>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

function convertHex(hex, opacity) {
	hex = hex.replace("#", "");
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);
	const result = "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
	return result;
}
